import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'AdROI completely transformed our lead generation. We went from struggling to get 10 leads a month to consistently closing 40+ high-ticket clients. Their focus on actual ROI is unmatched.',
    name: 'Michael Chen',
    role: 'CEO, TechFlow Solutions',
    image: 'https://i.pravatar.cc/150?img=11'
  }, {
    quote: "Finally, a marketing agency that speaks our language. They don't just run ads; they helped us optimize our entire sales funnel. The transparency in their reporting is exactly what we needed.",
    name: 'Sarah Jenkins',
    role: 'Marketing Director, Apex Health',
    image: 'https://i.pravatar.cc/150?img=5'
  }, {
    quote: 'We had been burned by three different agencies before finding AdROI. Within 90 days, they lowered our CPA by 45% and doubled our conversion rate. They are true partners in our growth.',
    name: 'David Rodriguez',
    role: 'Founder, Elevate Fitness',
    image: 'https://i.pravatar.cc/150?img=8'
  }];
  return <section className="py-24 bg-white" data-id="element-295" data-mp="78aaferw1ngp">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296" data-mp="79bqjxnrh05a">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-297" data-mp="c623ic49rfmh">
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4 tracking-tight" data-id="element-298" data-mp="c8ojn05873gb">
            Don't just take our word for it
          </h2>
          <p className="text-lg text-gray-600" data-id="element-299" data-mp="14u7pf2727anw">
            Hear from the businesses that have scaled their revenue with our
            proven systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-300" data-mp="v4xuzfoqtfwm">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 rounded-2xl p-8 relative" data-id="element-301" data-mp="1iuij0czr73cr" data-mpi={index}>
              <QuoteIcon className="absolute top-6 right-6 w-10 h-10 text-gray-200" data-id="element-302" data-mp="1jhg7mmyscg9d" />
              <div className="flex text-yellow-400 mb-6" data-id="element-303" data-mp="1ek6h13zntyjy">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-304" data-mp="19rmtpfb67p1y" />)}
              </div>
              <p className="text-gray-700 text-lg mb-8 relative z-10 italic" data-id="element-305" data-mp="14tv1slaj02xr">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center" data-id="element-306" data-mp="10px32bp44u58">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full mr-4 object-cover" data-id="element-307" data-mp="vrlvk7maivq6" />
                <div data-id="element-308" data-mp="32fujpk7fadi1">
                  <h4 className="font-bold text-gray-900" data-id="element-309" data-mp="32gdzovdiirtf">
                    {testimonial.name}
                  </h4>
                  <p className="text-sm text-gray-500" data-id="element-310" data-mp="37i3bid8k79ik">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}